/* eslint-disable import/prefer-default-export */
export const defaultProps = {
  maxScale: 4,
  minScale: 1,
  activeDotColor: '#4e99e9',
  dotColor: '#dadbdc',
  cut: 0,
};
